"use client"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

export function ContactForm() {
  return (
    <form
      className="space-y-6"
      onSubmit={(e) => {
        e.preventDefault()
        // Honeypot: drop submissions that filled the hidden "website"
        // field (form-fill bots do, humans can't see it). The squirrel
        // audit flagged the form as "1 public form(s) without CAPTCHA";
        // a honeypot + name="website" offscreen is a privacy-preserving
        // alternative that satisfies the check without dragging in
        // reCAPTCHA or an iframe tracker.
        const form = e.currentTarget as HTMLFormElement
        const honeypot = (
          form.elements.namedItem("website") as HTMLInputElement | null
        )?.value
        if (honeypot) return
      }}
    >
      {/* Honeypot — off-screen, not reachable by keyboard. Previously
       * wrapped in aria-hidden which the squirrel audit flagged
       * because a focusable <input> inside aria-hidden breaks WCAG
       * 4.1.2 (the element is hidden from AT yet still in the tab
       * order for sighted users). Switching to plain off-screen
       * positioning + tabIndex=-1: the input is unreachable by tab
       * AND still absent from the visual flow, but it's now
       * exposed to screen readers correctly (they'll read the
       * "Laisser vide" label) — which is the canonical honeypot
       * pattern. Form-fill bots ignore the instruction and fill it
       * anyway, which short-circuits the submit handler above. */}
      <div
        style={{
          position: "absolute",
          left: "-10000px",
          top: "auto",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
      >
        <Label htmlFor="website">
          Laisser ce champ vide (contrôle anti-spam)
        </Label>
        <Input
          id="website"
          name="website"
          type="text"
          tabIndex={-1}
          autoComplete="off"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="name">Nom Prenom *</Label>
        <Input
          id="name"
          name="name"
          type="text"
          placeholder="Votre nom et prenom"
          required
          className="transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out-expo)]"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Telephone *</Label>
        <Input
          id="phone"
          name="phone"
          type="tel"
          placeholder="Votre numero de telephone"
          required
          className="tabular-nums transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out-expo)]"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email *</Label>
        <Input
          id="email"
          name="email"
          type="email"
          placeholder="Votre adresse email"
          required
          className="transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out-expo)]"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="message">Message</Label>
        <Textarea
          id="message"
          name="message"
          placeholder="Votre message (optionnel)"
          className="min-h-32 transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out-expo)]"
        />
      </div>

      <Button type="submit" size="lg" className="w-full active:scale-[0.97] transition-[background-color,transform] duration-200 ease-[var(--ease-out-expo)]">
        Envoyer
      </Button>
    </form>
  )
}
